import { combineReducers } from 'redux'
import Session from './SessionReducer'
import Site from './SiteReducer'
import Workspace from './WorkspaceReducer'

export default combineReducers({
  Session,
  Site,
  Workspace,
})
